import { useId } from 'react';
import { cn } from '@/utils/cn';

interface ProviderCardGlowProps {
  className?: string;
}

export function ProviderCardGlow({ className }: ProviderCardGlowProps) {
  const rawId = useId();
  const safeId = rawId.replace(/:/g, '');

  const clipId = `provider-card-clip-${safeId}`;
  const filter0Id = `provider-card-filter0-${safeId}`;
  const filter1Id = `provider-card-filter1-${safeId}`;
  const paint0Id = `provider-card-paint0-${safeId}`;
  const paint1Id = `provider-card-paint1-${safeId}`;

  return (
    <div className={cn('group relative', className)}>
      <svg
        width="120"
        height="50"
        viewBox="0 0 120 50"
        preserveAspectRatio="none"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        <g clipPath={`url(#${clipId})`}>
          <rect width="120" height="50" fill="#1C0F29" />
          <g
            filter={`url(#${filter0Id})`}
            className="translate-y-0 transition-transform duration-300 group-hover:-translate-y-8"
          >
            <path
              d="M-24.6532 74.5414C-45.4683 103.154 -39.1474 143.223 -10.5351 164.038C18.0772 184.853 147.522 179.318 168.337 150.705C189.152 122.093 93.4554 81.2384 64.8431 60.4233C36.2308 39.6082 -3.83809 45.9291 -24.6532 74.5414Z"
              fill={`url(#${paint0Id})`}
            />
          </g>
          <g opacity="0.3" filter={`url(#${filter1Id})`}>
            <ellipse
              cx="73.9665"
              cy="41.0523"
              rx="73.9665"
              ry="41.0523"
              transform="matrix(-0.684198 -0.729296 0.0995052 -0.995037 141.258 90.8594)"
              fill={`url(#${paint1Id})`}
            />
          </g>
        </g>
        <defs>
          <filter
            id={filter0Id}
            x="-84.0124"
            y="1.06379"
            width="302.382"
            height="222.613"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="23.5482" result="effect1_foregroundBlur_27731_193459" />
          </filter>
          <filter
            id={filter1Id}
            x="20.2306"
            y="-95.3319"
            width="149.01"
            height="182.799"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="11.8652" result="effect1_foregroundBlur_27731_193459" />
          </filter>
          <linearGradient id={paint0Id} x1="77.5646" y1="95.9743" x2="-4.56671" y2="100.477" gradientUnits="userSpaceOnUse">
            <stop stopColor="#BD4DF9" />
            <stop offset="1" stopColor="#FE5104" />
          </linearGradient>
          <linearGradient id={paint1Id} x1="32.3298" y1="-5.33992" x2="196.656" y2="30.4544" gradientUnits="userSpaceOnUse">
            <stop offset="0.138301" stopColor="#42316D" />
            <stop offset="0.442308" stopColor="#6F3496" />
            <stop offset="1" stopColor="#6433BD" />
          </linearGradient>
          <clipPath id={clipId}>
            <rect width="120" height="50" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
